<template>
    <v-container class="fill-height" style="display: block;" fluid>

        <v-row>
            <v-col cols="12" lg="4">
                <v-card outlined class="card">
                    <v-card-title>Users</v-card-title>
                    <v-divider />
                    <v-card-text class="card-body">
                        <v-list>
                            <v-list-item-group v-model="selectedUserIndex" color="primary" @change="getUserSettings">
                                <v-list-item dense v-for="user in this.$store.state.batchConfig.users">
                                    <v-list-item-icon class="avatar-container">
                                        <img :src="user.userImage" v-if="user.userImage" />
                                        <v-icon x-large v-if="!user.userImage">fa fa-user-circle</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-title v-text="user.user_fullname"></v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list-item-group>
                        </v-list>
                    </v-card-text>
                </v-card>
            </v-col>

            <v-col cols="12" lg="4">
                <v-card outlined class="card">
                    <v-card-title>Settings</v-card-title>
                    <v-divider />
                    <v-card-text class="card-body">
                        <span class="empty-text" v-if="!selectedUser && !gettingUserSettings">Select a user</span>
                        <div class="getting-user-settings" v-if="gettingUserSettings">
                            <v-icon>fas fa-spinner fa-spin</v-icon>
                        </div>

                        <v-expansion-panels v-if="selectedUser && selectedUser.settings" light>
                            <v-expansion-panel v-for="setting in selectedUser.settings" :key="setting.key">
                                <v-expansion-panel-header>
                                    <v-checkbox v-model="setting.selected" class="small-box" color="#c42111" @click.native.stop.prevent></v-checkbox>
                                    <span>
                                        {{ setting.name }}
                                        <v-tooltip bottom color="rgba(97, 97, 97, 1.0)" v-if="isViewSetting(setting)">
                                            <template v-slot:activator="{ on }">
                                                <v-icon dark v-on="on">mdi-information-outline</v-icon>
                                            </template>
                                            <span>This will propagate favorites and defaults. Set views to 'Public' to allow other users access.</span>
                                        </v-tooltip>
                                    </span>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <pre>
                                        {{ JSON.stringify(setting.value, undefined, 4) }}
                                    </pre>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-expansion-panels>

                    </v-card-text>
                </v-card>
            </v-col>



            <v-col cols="12" lg="4">
                <v-card outlined class="card">
                    <v-card-title>
                        <span class="mr-2">Propagate To</span> <span v-if="propagateToUsers.length">{{ ` - ${propagateToUsers.length} users` }}</span>
                        <div class="flex-grow-1"></div>
                        <v-btn @click="applyPropagationClick" :disabled="!anySettingsSelected || !propagateToUsers.length" fab small color="#c42111" class="prop-button"><v-icon>mdi-account-multiple-check</v-icon></v-btn>
                    </v-card-title>

                    <v-divider />

                    <v-card-text class="card-body">
                        <span class="empty-text" v-if="!selectedUser && !gettingUserSettings">Select a user</span>
                        <v-list v-if="selectedUser && selectedUser.settings">
                            <v-list-item-group multiple v-model="propagateToUsers" color="#B2DFDB">
                                <v-list-item dense v-for="user in this.$store.state.batchConfig.users" :disabled="user.user_data.is_customer_admin || user.user_username == selectedUser.user_username">
                                    <template v-slot:default="{ active }">
                                        <v-list-item-icon class="avatar-container">
                                            <img :src="user.userImage" v-if="user.userImage" />
                                            <v-icon x-large v-if="!user.userImage">fa fa-user-circle</v-icon>
                                        </v-list-item-icon>

                                        <v-list-item-content>
                                            <v-list-item-title v-text="user.user_fullname"></v-list-item-title>
                                        </v-list-item-content>

                                        <v-list-item-action>
                                            <v-checkbox color="#c42111" :input-value="active"></v-checkbox>
                                        </v-list-item-action>
                                    </template>
                                </v-list-item>
                            </v-list-item-group>
                        </v-list>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

    </v-container>
</template>

<script>
import Vue from 'vue';
export default {
    name: 'Propagation',
    props: [],
    components: {
    },
    data: () => ({
        selectedUserIndex: null,
        selectedUser: null,
        gettingUserSettings: false,

        propagateToUsers: []
    }),

    computed: {
        propagateToUsersObj: function() {
            let value = [];
            if(this.propagateToUsers.length) {
                for(let i of this.propagateToUsers) {
                    value.push(this.$store.state.batchConfig.users[i]);
                }
            }
            return value;
        },

        anySettingsSelected: function() {
            if(this.selectedUser && this.selectedUser.settings) {
                return this.selectedUser.settings.some(s => {return s.selected});
            }
            return false;
        }
    },

    methods: {
        getUserSettings: function() {
            if(this.selectedUserIndex === undefined) {
                this.selectedUser = null;
                this.propagateToUsers = [];
                return;
            }
            this.selectedUser = this.$store.state.batchConfig.users[this.selectedUserIndex];
            this.gettingUserSettings = true;
            let route = (TELSA.apiHost + "settings/user");
            this.$http.post(route, {args: {username: this.selectedUser.user_username}}).then(response => {
                let result = response.body;
                this.gettingUserSettings = false;
                // this makes the new object prop reactive
                Vue.set(this.selectedUser, 'settings', result);
            });
        },

        applyPropagationClick: function() {
            let selectedSettingsStr = (this.selectedUser.settings.filter(s => {return s.selected}).map(ss => {return ss.name})).join(', ');
            this.$store.commit('showConfirmModal', {
                title: 'Are you sure?',
                message: `Are you sure you want to apply <b>${this.selectedUser.user_username}'s</b> [${selectedSettingsStr}] settings to <b>${this.propagateToUsers.length}</b> user(s)? This will overwrite any existing settings they have.`,
                type: 'warning',
                hideCancel: false,
                confirmAction: () => this.applyPropagation()
            });
        },

        applyPropagation: function() {
            TELSA.loading(true);
            let route = (TELSA.apiHost + "settings/propagate");
            this.$http.post(route, {args: {settings: this.selectedUser.settings, users: this.propagateToUsersObj}}).then(response => {
                let result = response.body;
                this.selectedUser = null;
                this.propagateToUsers = [];
                TELSA.loading(false);
            });
        },

        isViewSetting: function(setting) {
            let setting_keys = ['alarm_views_favs', 'geomap_views_favs', 'issue_views_favs'];
            return setting_keys.includes(setting.key);
        }
    },

    mounted() {

    }

  
};
</script>

<style scoped>

    .card {
        overflow-y: auto;
        /* max-height: calc(100vh - 224px); */
        max-height: calc(100vh - 200px);
        position: relative;
    }

    .card-body {
        overflow-y: auto;
        /* max-height: calc(100vh - 310px); */
        max-height: calc(100vh - 270px);
        position: relative;
    }

    .avatar-container {
        height: 40px;
        width: 40px;
        border-radius: 50%;
        box-shadow: 3px 3px 8px 0px rgba(0,0,0,0.5);
    }
    .avatar-container img {
        border-radius: 50%;
        height: 40px;
        width: 40px;
    }

    .empty-text {
        text-align: center;
        font-size: 22px;
        margin-top: 30px;
        margin-bottom: 30px;
        display: block;
    }


    .getting-user-settings {

    }
    .getting-user-settings i {
        font-size: 110px;
        margin: 20px calc(50% - (110px / 2));
    }

    .small-box {
        height: 25px;
        margin: 0px;
        padding: 0px;
    }

    .prop-button {
        position: absolute;
        right: 20px;
    }

</style>
